/**
 * Gösterim makalesi: bilinçli olarak yerleştirilmiş raporlama hataları içerir.
 *
 * Amaç, motorun neyi yakaladığını tek tıkla görebilmek. Hatalar:
 *  1. t(48) = 2.41, p = .12   → hesaplanan p ≈ .020 (eşik geçişi)
 *  2. F(1, 96) = 4.86, p = .030 → hesaplanan p ≈ .030 (tutarlı kontrol)
 *  3. χ²(2) = 8.42, p = .015  → hesaplanan p ≈ .015 (tutarlı kontrol)
 *  4. r(148) = .31, p , .001  → operatör kaybı + yeniden hesaplama
 *  5. Öz'tte "anlamlı" iddiası, sayısal destek yok
 *  6. İlişkisel desende "neden oldu", "etkiledi" gibi nedensel dil
 *  7. "Tablo 2" metinde var, altyazısı yok; "Tablo 3" altyazısı var, atıf yok
 *  8. Metin içi atıf (Kaya, 2021) kaynakçada yok
 *  9. Kaynakçada (Aydın, 2018) var, metinde atıf yok
 * 10. "kanıtlamaktadır", "kesinlikle" gibi aşırı iddia ifadeleri
 */

export const DEMO_ARTICLE = `Sosyal Medya Kullanımı ve Akademik Erteleme: İlişkisel Bir Çalışma

Öz
Bu çalışmada üniversite öğrencilerinde sosyal medya kullanım süresi ile akademik erteleme davranışı arasındaki ilişki incelenmiştir. Araştırmaya 150 lisans öğrencisi katılmıştır. Bulgular, sosyal medya kullanımının akademik erteleme üzerinde anlamlı bir etkisi olduğunu göstermektedir. Elde edilen sonuçlar, sosyal medya kullanımının öğrencilerin akademik başarısını kesinlikle düşürdüğünü kanıtlamaktadır.

Giriş
Akademik erteleme, öğrencilerin görevlerini kasıtlı olarak geciktirmesi olarak tanımlanmaktadır (Yılmaz, 2019). Alanyazında erteleme davranışının çok sayıda değişkenle ilişkili olduğu belirtilmektedir. Son yıllarda dijital teknolojilerin yaygınlaşmasıyla birlikte sosyal medya kullanımı da bu değişkenler arasında sayılmaktadır (Demir & Şahin, 2020; Kaya, 2021). Bununla birlikte, ülkemizde bu iki değişkeni birlikte inceleyen sınırlı sayıda çalışma bulunmaktadır. Bu nedenle mevcut araştırmada sosyal medya kullanımı ile akademik erteleme arasındaki ilişkinin incelenmesi amaçlanmıştır.

Yöntem
Araştırma ilişkisel tarama deseninde tasarlanmıştır. Katılımcılar, bir devlet üniversitesinin farklı fakültelerinde öğrenim gören 150 lisans öğrencisinden oluşmaktadır. Veriler, kolayda örnekleme yöntemiyle ve çevrimiçi anket aracılığıyla toplanmıştır. Katılımcıların 84'ü kadın (%56), 66'sı erkektir (%44). Veri toplama araçları olarak Kişisel Bilgi Formu, Sosyal Medya Kullanım Ölçeği ve Akademik Erteleme Ölçeği kullanılmıştır. Verilerin analizinde Pearson korelasyon katsayısı ve basit doğrusal regresyon analizi kullanılmıştır.

Bulgular
Katılımcıların sosyal medya kullanım süresi ile akademik erteleme puanları arasında pozitif yönde anlamlı bir ilişki bulunmuştur, r(148) = .31, p , .001. Buna göre sosyal medya kullanımı arttıkça akademik erteleme eğilimi de artmaktadır.

Cinsiyete göre akademik erteleme puanları arasında anlamlı bir fark bulunmamıştır, t(48) = 2.41, p = .12. Kadın ve erkek öğrencilerin ortalama puanları birbirine oldukça yakındır.

Sınıf düzeyine göre sosyal medya kullanım süreleri arasında anlamlı bir fark bulunmuştur, F(1, 96) = 4.86, p = .030. Birinci sınıf öğrencileri üst sınıflara göre daha fazla sosyal medya kullanmaktadır.

Sosyal medya kullanım sıklığı ile cinsiyet arasındaki ilişki ki-kare analiziyle incelenmiş ve anlamlı bulunmuştur, χ²(2) = 8.42, p = .015.

Tablo 1'de değişkenlere ilişkin betimsel istatistikler sunulmuştur.

Tablo 1: Değişkenlere ilişkin betimsel istatistikler
Değişken | Ort. | SS | Çarpıklık | Basıklık
Sosyal medya kullanımı | 3.42 | 0.88 | -0.31 | 0.24
Akademik erteleme | 2.87 | 0.74 | 0.42 | -0.11

Tablo 2'de regresyon analizi sonuçları verilmiştir. Buna göre sosyal medya kullanımı, akademik ertelemenin anlamlı bir yordayıcısıdır, β = .29, p < .001.

Tablo 3: Basit doğrusal regresyon sonuçları
Değişken | B | SH | β | t | p
Sosyal medya | 0.24 | 0.06 | .29 | 3.91 | < .001

Tartışma
Bu çalışmanın bulguları, sosyal medya kullanımının akademik erteleme davranışını etkilediğini göstermektedir. Buna göre sosyal medyada geçirilen süre, öğrencilerin çalışma alışkanlıklarını bozmuş ve erteleme davranışına neden olmuştur. Bu sonuç, alanyazındaki çalışmalarla tutarlıdır (Demir & Şahin, 2020). Ancak elde edilen bulgular tüm öğrenciler için genellenebilir niteliktedir.

Sosyal medya kullanımının azaltılmasına yönelik müdahaleler, öğrencilerin akademik performansını iyileştirecektir. Bu bulgular, sosyal medyanın akademik hayat üzerindeki olumsuz etkisini kanıtlamaktadır. Gelecek çalışmalarda boylamsal desenlerin kullanılması önerilmektedir.

Sonuç
Sosyal medya kullanımı ile akademik erteleme arasında anlamlı bir ilişki olduğu kesinlikle söylenebilir.

Kaynakça
Aydın, M. (2018). Üniversite öğrencilerinde erteleme davranışının yordayıcıları. Eğitim ve Bilim, 43(195), 121-138.
Demir, S., & Şahin, R. (2020). Sosyal medya bağımlılığı ve akademik başarı ilişkisi. Psikoloji Çalışmaları, 40(2), 441-468.
Yılmaz, A. (2019). Akademik erteleme: Kuramsal bir derleme. Türk Psikoloji Yazıları, 22(44), 78-96.
`;

export const DEMO_FILE_NAME = 'ornek-makale-sosyal-medya.txt';
